'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.set = exports.get = undefined;
exports.getUtk = getUtk;

var _cookies = require('hub-http/helpers/cookies');

var get = exports.get = function get(key) {
  return (0, _cookies.getCookie)(key, document.cookie);
};

var set = exports.set = function set(key, value) {
  var expiresInMillis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60 * 24 * 60 * 60 * 1000;

  var currentTime = new Date();
  var expiryTime = new Date(currentTime.setTime(currentTime.getTime() + expiresInMillis)).toUTCString();
  document.cookie = key + '=' + value + ';expires=' + expiryTime + ';path=/';
};

function getHstc() {
  return get('__hstc');
}

function getUtk() {
  var utk = get('hubspotutk');
  if (!utk) {
    utk = getHstc();
    if (utk) {
      utk = utk.split('.')[1];
    }
  }
  return utk || null;
}